import React, { useContext, useState } from 'react';
import { SessionContext } from './api/sessionExtension';
import { LoginApiContext } from './api/LoginApiContext';
import { useIntl } from 'react-intl';
import translations from './app.i18n';
import {
  AlpNotificationType,
  NotificationFunctionContext,
} from './components/notifications/notificationProvider';
import { HttpError } from './api/generated/studiested-generated-api';
import { uuidv4 } from './util/uuidv4';
import { ConfirmationDialog } from './components/dialog';

const TimeoutWarning = () => {
  const { showTimeoutWarning, resetShowTimeoutWarning } =
    useContext(SessionContext);
  const { loginApi } = useContext(LoginApiContext);
  const { formatMessage } = useIntl();
  const labels = {
    modalTitle: formatMessage({ id: translations.modalTitle.id }),
    modalText: formatMessage({ id: translations.modalText.id }),
    modalConfirm: formatMessage({ id: translations.modalConfirm.id }),
    modalCancel: formatMessage({ id: translations.modalCancel.id }),
  };
  const { addNotification } = useContext(NotificationFunctionContext);

  const [seconds, setSeconds] = useState(59);
  const [minutes, setMinutes] = useState(4);

  React.useEffect(() => {
    if (!showTimeoutWarning) {
      setMinutes(4);
      setSeconds(59);
    } else if (seconds > 0 && showTimeoutWarning) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    } else if (minutes === 0 && seconds === 0) {
      window.location.href = '/login/logout';
    } else if (seconds === 0) {
      setMinutes(minutes - 1);
      setSeconds(59);
    }
  }, [
    seconds,
    showTimeoutWarning,
    setSeconds,
    minutes,
    loginApi,
    addNotification,
    resetShowTimeoutWarning,
  ]);

  const formatSeconds = seconds < 10 ? '0' + seconds : seconds;
  const formatMinutes = minutes < 10 ? '0' + minutes : minutes;

  const countdownTime = formatMinutes + ':' + formatSeconds;

  const modalClose = (ok: boolean) => {
    if (ok) {
      loginApi.userroleGet().catch((err: HttpError) => {
        addNotification({
          id: uuidv4(),
          type: AlpNotificationType.ERROR,
          message: err.body,
        });
      });
      resetShowTimeoutWarning();
    } else {
      window.location.href = '/login/logout';
    }
  };

  return (
    <ConfirmationDialog
      isOpen={showTimeoutWarning}
      title={labels.modalTitle}
      subtitle={countdownTime}
      children={labels.modalText}
      submitLabel={labels.modalConfirm}
      cancelLabel={labels.modalCancel}
      onClose={modalClose}
    />
  );
};

export default TimeoutWarning;
